'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModuleProviderFactory;

var _utils = require('../utils');

var _Provider = require('../Provider');

var _Provider2 = _interopRequireDefault(_Provider);

var _State = require('./State');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function ModuleProviderFactory(devtools) {
  return (0, _Provider2.default)(_State.methods.reduce(function (currentState, methodKey) {
    currentState[methodKey] = function () {
      var _context$state;

      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      path = (0, _utils.ensurePath)(path);
      var signalPath = this.context.execution.name.split('.');
      var modulePath = signalPath.splice(0, signalPath.length - 1);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_context$state = this.context.state)[methodKey].apply(_context$state, [modulePath.concat(path)].concat(args));
    };

    return currentState;
  }, {}), {
    wrap: devtools ? function (context, functionDetails) {
      return _State.methods.reduce(function (currentState, methodKey) {
        if (methodKey === 'get' || methodKey === 'compute') {
          currentState[methodKey] = function (path) {
            path = (0, _utils.ensurePath)(path);
            var signalPath = context.execution.name.split('.');
            var modulePath = signalPath.splice(0, signalPath.length - 1);

            path = modulePath.concat(path);

            return context.state[methodKey](path);
          };
        } else {
          var originFunc = context.state[methodKey];

          currentState[methodKey] = function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            var argsCopy = args.slice();
            var path = (0, _utils.ensurePath)(argsCopy.shift());
            var signalPath = context.execution.name.split('.');
            var modulePath = signalPath.splice(0, signalPath.length - 1);

            path = modulePath.concat(path);

            context.debugger.send({
              datetime: Date.now(),
              type: 'mutation',
              color: '#333',
              method: 'module.' + methodKey,
              args: [path].concat(_toConsumableArray(argsCopy))
            });

            try {
              originFunc.apply(context.state, [path].concat(_toConsumableArray(argsCopy)));
            } catch (e) {
              var signalName = context.execution.name;
              (0, _utils.throwError)('The Signal "' + signalName + '" with action "' + functionDetails.name + '" has an error: ' + e.message);
            }
          };
        }

        return currentState;
      }, {});
    } : false
  });
}
//# sourceMappingURL=Module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/providers/Module.js
// module id = 247
// module chunks = 0